export default "__VITE_ASSET__88aAeWLG__"